/**
 * CTA Tracking Utility
 * Handles click tracking for Call-to-Action buttons
 */

export function trackCTAClick(
  ctaId?: string, 
  ctaPosition?: string,
  ctaVariant: string = 'primary'
): void {
  if (typeof window === 'undefined') return;
  
  // Store CTA data in sessionStorage before navigation
  if (ctaId) sessionStorage.setItem('cta_id', ctaId);
  if (ctaPosition) sessionStorage.setItem('cta_position', ctaPosition);
  if (ctaVariant) sessionStorage.setItem('cta_variant', ctaVariant);
  
  // Push to dataLayer for GTM
  if ((window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: 'cta_click',
      cta_id: ctaId,
      cta_position: ctaPosition,
      cta_variant: ctaVariant,
    });
  }
}
